import axios from 'axios';
import { message } from 'antd'; // 示例：用 AntD 的 message 提示错误（可替换为其他 UI 库）

// 1. 创建 Axios 实例，配置基础路径、超时时间
const service = axios.create({
    baseURL: '/proxy', // 从环境变量读取接口前缀（推荐）
    timeout: 5000, // 超时时间 5s
    headers: {
        'Content-Type': 'application/json', // 默认请求头：JSON 格式
    },
});

// 2. 请求拦截器：发送请求前做处理（如加 Token）
service.interceptors.request.use(
    (config) => {
        // 示例：从 localStorage 读取 Token，添加到请求头（权限认证）
        const token = localStorage.getItem('token');
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`; // 格式按后端要求（如 Token、JWT）
        }
        return config;
    },
    (error) => {
        // 请求发送失败（如网络错误）
        message.error('请求发送失败，请检查网络');
        return Promise.reject(error);
    }
);

// 3. 响应拦截器：接收响应后统一处理（格式化数据、错误提示）
service.interceptors.response.use(
    (response) => {
        const res = response.data; // 后端返回的原始数据（如 { code: 200, data: {}, msg: "" }）

        // 按后端约定的状态码判断成功/失败（示例：code=200 为成功）
        if (res.code !== 200) {
            // 失败：提示错误信息（后端返回的 msg）
            message.error(res.msg || '接口请求失败');
            return Promise.reject(res); // 抛出错误，让组件捕获处理
        } else {
            // 成功：直接返回 data 字段（组件无需关注 code/msg）
            return res.data;
        }
    },
    (error) => {
        // 响应失败（如 404 接口不存在、500 后端报错、超时）
        const status = error.response?.status;
        switch (status) {
            case 401:
                message.error('未登录或 Token 过期，请重新登录');
                // 跳转至登录页（需结合 react-router）
                window.location.href = '/login';
                break;
            case 404:
                message.error('请求的接口不存在');
                break;
            case 500:
                message.error('后端服务器报错，请联系管理员');
                break;
            default:
                message.error('请求失败：' + (error.message || '未知错误'));
        }
        return Promise.reject(error);
    }
);

export default service;